module.exports = __webpack_public_path__ + "img/error-neck.77997175.svg";